import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const regExDes = /^[a-zA-Z0-9][a-zA-Z0-9\s-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]*$/;
class AddTermsandCondition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        termsUrl: "",
        termsV: "",
        privacyUrl: "",
        privacyV: ""
      }
    };
    this.onChange = this.onChange.bind(this);
    this.submit = this.submit.bind(this);
    this.closeModel = this.closeModel.bind(this);
  }

  onChange(event) {
    let name = event.target.name;
    let value = event.target.value;
    if (name === "termsUrl") {
      if (value === "" || regExDes.test(value)) {
        this.setState({
          value: { ...this.state.value, termsUrl: value }
        });
        console.log("++++++++++++++++++++++++++++", value);
      }
    } else if (name === "termsV") {
      if (value === "" || regExDes.test(value)) {
        this.setState({
          value: { ...this.state.value, termsV: value }
        });
        console.log("++++++++++++++++++++++++++++", value);
      }
    } else if (name === "privacyUrl") {
      if (value === "" || regExDes.test(value)) {
        this.setState({
          value: { ...this.state.value, privacyUrl: value }
        });
        console.log("++++++++++++++++++++++++++++", value);
      }
    } else if (name === "privacyV") {
      if (value === "" || regExDes.test(value)) {
        this.setState({
          value: { ...this.state.value, privacyV: value }
        });
        console.log("++++++++++++++++++++++++++++", value);
      }
    }
  }

  submit() {
    let data = this.state.value;
    console.log("data+++++data+++++", data);
    if (
      data.termsUrl !== "" &&
      data.termsV !== "" &&
      data.privacyUrl !== "" &&
      data.privacyV !== ""
    ) {
      this.props.AddTrmsadCndtn(this.state.value);
      this.setState({
        value: {
          termsUrl: "",
          termsV: "",
          privacyUrl: "",
          privacyV: ""
        }
      });
      this.props.closeAddModel();
      //   this.props.resetPage();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }
  }

  closeModel() {
    this.setState({
      value: {
        termsUrl: "",
        termsV: "",
        privacyUrl: "",
        privacyV: ""
      }
    });
    this.props.closeAddModel();
  }

  render() {
    return (
      <div>
        <div>
          <Modal
            show={this.props.showTrmsadCndtnAddModel}
            onHide={this.closeModel}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Terms & Conditions</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Container>
                <Form>
                  <Row>
                    <Col lg={6} sm={12} xs={12}>
                      <Form.Group controlId="termsUrl">
                        <Form.Label>Terms Url</Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="termsUrl"
                          onChange={this.onChange}
                          value={this.state.value.termsUrl}
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={6} sm={12} xs={12}>
                      <Form.Group controlId="termsV">
                        <Form.Label>Terms Version</Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="termsV"
                          value={this.state.value.termsV}
                          onChange={this.onChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} sm={12} xs={12}>
                      <Form.Group controlId="privacyUrl">
                        <Form.Label>Privacy Url</Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="privacyUrl"
                          onChange={this.onChange}
                          value={this.state.value.privacyUrl}
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={6} sm={12} xs={12}>
                      <Form.Group controlId="privacyV">
                        <Form.Label>Privacy Version</Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="privacyV"
                          value={this.state.value.privacyV}
                          onChange={this.onChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Container>
            </Modal.Body>

            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
              <Button onClick={this.submit}>Submit</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}
export default AddTermsandCondition;
